import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AdminService } from '../services/admin.service';
import { WaitModalComponent } from '../shared/components/waitmodal/waitmodal.component';

@Component({
  selector: 'app-admin-root',
  standalone: false,
  templateUrl: './admin-root.component.html',
  styleUrls: ['./admin-root.component.scss'],
})
export class AdminRootComponent implements OnInit, OnDestroy {
  // Event Handlers
  private adminLoadedEventHandler: Subscription;

  private waitModalRef: NgbModalRef;
  private showWaitTimeoutRef: any;

  constructor(
    private adminService: AdminService,
    private modalService: NgbModal
  ) {
    this.adminLoadedEventHandler = this.adminService.adminServiceLoadedEvent.subscribe(
      () => {
        this.closeWaitModal();
      }
    );
  }

  ngOnInit(): void {
    this.showWaitTimeoutRef = setTimeout(() => {
      // show wait
      if (!this.adminService.isReady) this.showWaitModal();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.adminLoadedEventHandler)
      this.adminLoadedEventHandler.unsubscribe();
  }

  showWaitModal() {
    this.waitModalRef = this.modalService.open(WaitModalComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
  }
  closeWaitModal() {
    clearTimeout(this.showWaitTimeoutRef);
    if (this.waitModalRef) this.waitModalRef.close();
  }
}
